<template>
    <va-form :id="id" :item="item">
        <v-row justify="center">
            <v-col sm="6">
                <base-material-card>
                    <template v-slot:heading>
                        <div class="display-2">
                            {{ title }}
                        </div>
                    </template>
                    <v-card-text>
                        <va-date-input source="before"></va-date-input>
                        <va-date-input source="after"></va-date-input>
                        <va-text-input source="additional_data"></va-text-input>
                    </v-card-text>
                    <va-save-button></va-save-button>
                </base-material-card>
            </v-col>
        </v-row>
    </va-form>
</template>

<script>
import FinancialEventStatuses from "@/constants/FinancialEventStatuses";

export default {
    props: ["id", "title", "item"],
    data() {
        return {
            choices: FinancialEventStatuses,
        };
    },
};
</script>
